module.exports = __webpack_public_path__ + "static/img/statusonline1.79d399d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/statusonline1.png
// module id = 1269
// module chunks = 0